import React, { useState, useEffect } from 'react';
import { Table, Card, Typography, Space, Tag, message, Row, Col } from 'antd';
import { TrophyOutlined, TeamOutlined, StarFilled } from '@ant-design/icons';
import { adminAPI } from '../../utils/api';

const { Title, Text } = Typography;

const Coaches = () => {
    const [loading, setLoading] = useState(false);
    const [coaches, setCoaches] = useState([]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await adminAPI.getCoaches();
            setCoaches(response.data.coaches || []);
        } catch (error) {
            console.error('Failed to fetch coaches:', error);
            message.error('Failed to load coach rewards data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const columns = [
        {
            title: 'Coach Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => (
                <Space>
                    <StarFilled style={{ color: '#faad14' }} />
                    <Text strong>{text}</Text>
                </Space>
            )
        },
        {
            title: 'Active Consumers',
            dataIndex: 'consumer_count',
            key: 'consumer_count',
            sorter: (a, b) => a.consumer_count - b.consumer_count,
            render: (count) => (
                <Space>
                    <TeamOutlined />
                    <Text>{count} Users</Text>
                </Space>
            )
        },
        {
            title: 'Reward Points',
            dataIndex: 'reward_points',
            key: 'reward_points',
            sorter: (a, b) => a.reward_points - b.reward_points,
            render: (points) => (
                <Tag color="gold" style={{ fontSize: '14px', padding: '4px 12px', borderRadius: '15px' }}>
                    <TrophyOutlined style={{ marginRight: 8 }} />
                    {points} PTS
                </Tag>
            )
        }
    ];

    return (
        <div>
            <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                <Col span={24}>
                    <Card style={{ background: '#001529', borderRadius: '12px' }}>
                        <Space direction="vertical">
                            <Title level={2} style={{ color: 'white', margin: 0 }}>
                                <TrophyOutlined style={{ marginRight: 12 }} />
                                Coach Rewards Program
                            </Title>
                            <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: '16px' }}>
                                Coaches earn 100 points for every active member assigned to them.
                            </Text>
                        </Space>
                    </Card>
                </Col>
            </Row>

            <Card className="shadow-sm" style={{ borderRadius: '12px' }}>
                <Table
                    columns={columns}
                    dataSource={coaches}
                    rowKey="id"
                    loading={loading}
                    pagination={false}
                    className="rewards-table"
                />
            </Card>
        </div>
    );
};

export default Coaches;
